import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

// ============================================================
// FYUNOR — Application Shell
// The responsive page layout every route renders inside.
// Header (floating glass ribbon) + main content + footer.
// ============================================================

export default function AppShell({ children }) {
  return (
    <div className="flex min-h-dvh flex-col overflow-x-hidden bg-background">
      <Header />
      <main className="flex-1">{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
}